var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIconSeconday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9762 0.177734C25.6061 0.177734 26.9312 1.46799 26.9312 3.05998V4.50111H0.335938V3.05998C0.335938 1.46799 1.65878 0.177734 3.29097 0.177734H23.9762ZM26.9312 17.4712C26.9312 19.061 25.6061 20.3535 23.9762 20.3535H3.29097C1.65878 20.3535 0.335938 19.061 0.335938 17.4712V8.82448H26.9312V17.4712ZM5.50724 14.589C5.10093 14.589 4.76848 14.9132 4.76848 15.3095C4.76848 15.7058 5.10093 16.0301 5.50724 16.0301H8.46227C8.86859 16.0301 9.20103 15.7058 9.20103 15.3095C9.20103 14.9132 8.86859 14.589 8.46227 14.589H5.50724ZM11.4173 16.0301H17.3274C17.7337 16.0301 18.0661 15.7058 18.0661 15.3095C18.0661 14.9132 17.7337 14.589 17.3274 14.589H11.4173C11.011 14.589 10.6785 14.9132 10.6785 15.3095C10.6785 15.7058 11.011 16.0301 11.4173 16.0301Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIconSeconday);
export default __webpack_public_path__ + "static/media/credit_cardIcon_seconday.b82bd02d668f6a87bc55dd1eb75e712b.svg";
export { ForwardRef as ReactComponent };